import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../../Utility/Utilitys";
import { confirmAlert } from "react-confirm-alert";
import { getGlobals } from "../../../Configs";
import { useSelector } from "react-redux";

const AccordianDetailsV1 = ({
  index = 0,
  countingDetail = [],
  setCountingDetail,
  vMediaQuery,
  fKeyTabInput = {},
  isGridLoading = false,
  setIsGridLoading,
  rowData = {},
  panelDataLoaded = false,
  item = {},
  barcodeDetail = "",
}) => {
  const [detailGridData, setDetailGridData] = useState([]);
  //   const [isExpand, setIsExpand] = useState(false);

  //isExpand =true

  const vRdxuserInfo = useSelector((state) => state.login.value);
  const baseURL = getGlobals().API_BASE_URL;

  useEffect(() => {
    // if(isExpand){
    //     set -expand false
    // }

    if (panelDataLoaded && isGridLoading) {
      getRowDetailApi(index); // only call if it's the first load
    }
  }, [panelDataLoaded, isGridLoading]);

  const getRowDetailApi = async (index) => {
    if (!isGridLoading) return;
    const itemCode = item.B_ItmCd;
    if (!itemCode) return;
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}cyclicCount/cyclicCountItemDetailGetRow`,
        fcheck_null_undefine_replace_empty({
          SheetId: rowData.A_SheetId,
          C_ItmCd: itemCode,
        })
      );

      if (response?.status === 200) {
        let GridID = response?.data?.recordset?.map((obj, i) => ({
          ...obj,
          id: i + 1,
        }));
        setDetailGridData(GridID);

        const addedQty = response?.data?.recordset?.reduce(
          (sum, item) => sum + parseFloat(item.C_Qty || 0),
          0
        );

        const updatedCountingDetail = countingDetail?.map((entry) =>
          entry.B_ItmCd === item.B_ItmCd ? { ...entry, Qty: addedQty } : entry
        );
        setCountingDetail(updatedCountingDetail);
        loader.style.display = "none";
      }
    } catch (error) {
      loader.style.display = "none";
      console.error("Error fetching cycle count data:", error);
    }
  };

  const [unitData, setUintData] = useState([]);
  const [itemDetails, setItemDetails] = useState({
    barcode: barcodeDetail || "",
    itemCode: "",
    itemName: "",
    unit: unitData.length > 0 ? unitData[0]?.UnitCode : "",
    baseQty: 0,
    srNo: 0,
    quantity: 0,
  });

  let initError = {
    dateValue: "",
    location: "",
    selectedUser: "",
    barcode: "",
    itemCode: "",
    itemName: "",
    quantity: "",
    unit: "",
    baseQty: "",
    srNo: "",
  };
  const [errors, setErrors] = useState(initError);

  const handleDetailChange = (field, value) => {
    setItemDetails((prev) => ({
      ...prev,
      [field]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const handleSave = (index) => {
    let validationErrors = {};

    if (
      !itemDetails?.barcode ||
      itemDetails?.barcode === undefined ||
      itemDetails?.barcode === null
    ) {
      validationErrors.barcode = "BarCode is required";
      fAlertToast("FAILED", "BarCode is required");
    }

    if (
      !itemDetails?.itemCode ||
      itemDetails?.itemCode === undefined ||
      itemDetails?.itemCode === null
    )
      validationErrors.itemCode = "Item Code is required";
    // fAlertToast("FAILED", "Item Code is required");

    if (itemDetails?.itemCode !== item.B_ItmCd) {
      validationErrors.itemCode = `Current Item Code ${itemDetails?.itemCode} is not matched with detail Item Code ${item.B_ItmCd}`;
      fAlertToast(
        "FAILED",
        `Current Item Code ${itemDetails?.itemCode} is not matched with detail Item Code ${item.B_ItmCd}`
      );
    }

    if (
      parseFloat(itemDetails?.quantity) === parseFloat(0) ||
      itemDetails?.quantity === undefined ||
      itemDetails?.quantity === null
    ) {
      validationErrors.quantity = "Qty should not be zero";
      fAlertToast("FAILED", "Qty should not be zero");
    }

    if (
      !itemDetails?.unit ||
      itemDetails?.unit === undefined ||
      itemDetails?.unit === null
    ) {
      validationErrors.unit = "Unit is required";
      fAlertToast("FAILED", "Unit is required");
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    } else {
      saveApi(index);
    }
  };

  const getBarcodeApi = async (index) => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}cyclicCount/cyclicCountBarcodeScan`,
        fcheck_null_undefine_replace_empty({
          v_Barcode: itemDetails?.barcode, // ✅ Fetch barcode for specific index
          v_Loc: rowData?.A_Loc,
        })
      );

      if (response?.status === 200) {
        let result = response?.data?.recordset;
        loader.style.display = "none";
        if (result?.length > 0) {
          if (result[0]?.Unit !== "") {
            // const newUnitData = [
            //   {
            //     UnitCode: result[0]?.Unit,
            //     UnitName: result[0]?.UnitName,
            //   },
            // ];
            // setUintData(newUnitData); // ✅ Store UnitCode and UnitName in unitData array
            getUintData(result[0]?.ItmCd);
            setItemDetails((prev) => ({
              ...prev,
              barcode: result[0]?.Barcode,
              itemCode: result[0]?.ItmCd,
              itemName: result[0]?.Name2,
              unit: result[0]?.Unit, // ✅ Store UnitCode
            }));
            loader.style.display = "none";
          } else {
            getUintData(result[0]?.ItmCd);

            loader.style.display = "none";
          }

          setErrors(initError);

          setTimeout(() => {
            document.getElementById(`quantity-${index}`)?.focus();
          }, 400);
        } else {
          fAlertToast("FAILED", "Barcode not found");
        }
      } else {
        fAlertToast("FAILED", "Failed to fetch barcode details");
      }
    } catch (error) {
      fAlertToast("ERROR", "An error occurred while scanning the barcode");
      loader.style.display = "none";
    }
  };

  const saveApi = async (index) => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}cyclicCount/physicalStockUpdate`,
        fcheck_null_undefine_replace_empty({
          P_C_SheetId: rowData.A_SheetId,
          P_C_ItmCd: itemDetails?.itemCode,
          P_C_Qty: Number(itemDetails?.quantity),
          P_C_Unit: itemDetails?.unit,
          P_C_BaseQty: itemDetails?.baseQty || 0,
          P_C_SrNo: itemDetails?.srNo || 0,
          P_C_Barcode: itemDetails?.barcode,
        })
      );

      if (response?.status === 200) {
        fAlertToast("SUCCESS", "Line items saved successfully");
        loader.style.display = "none";
        fNew(index);
      } else {
        fAlertToast("FAILED", "Failed to save line items");
      }
    } catch (error) {
      let errorMessage = error?.response?.data?.message;

      fAlertToast("FAILED", `Error: ${errorMessage}`);
    } finally {
      loader.style.display = "none";
    }
  };

  const deleteApi = async (index) => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}cyclicCount/physicalStockDelete`,
        fcheck_null_undefine_replace_empty({
          P_C_SheetId: rowData?.A_SheetId,
          P_C_SrNo: itemDetails?.srNo,
          P_UserCd: vRdxuserInfo?.UserID,
        })
      );

      if (response?.status === 200) {
        fAlertToast("SUCCESS", "Line items deleted successfully");
        fNew(index);

        loader.style.display = "none";
      }
    } catch (error) {
      console.error("Error fetching cycle count data:", error);

      let errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "An unexpected error occurred.";

      fAlertToast("FAILED", `Error: ${errorMessage}`);
    } finally {
      loader.style.display = "none";
    }
  };

  const handleRowClick = (row, index) => {
    getUintData(row?.C_ItmCd);
    // const newUnitData = [
    //   {
    //     UnitCode: row?.C_Unit,
    //     UnitName: row?.C_UnitName,
    //   },
    // ];
    // setUintData(newUnitData);
    setItemDetails({
      srNo: row?.C_SrNo,
      itemCode: row?.C_ItmCd,
      itemName: row?.ItmName,
      baseQty: row?.C_BaseQty,
      quantity: row?.C_Qty,
      unit: row?.C_Unit,
      barcode: row?.C_Barcode,
    });
    setErrors(initError);
    setTimeout(() => {
      document.getElementById(`quantity-${index}`)?.focus();
    }, 600);
  };

  const getUintData = async (itemCode) => {
    if (!itemCode) return;
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}cyclicCount/NotionUom`,
        fcheck_null_undefine_replace_empty({
          v_ItmCd: itemCode,
          v_Unit: "",
          v_Loc: "05", //check with sir ---rowData?.A_Loc,
        })
      );

      if (response?.status === 200) {
        if (response?.data?.length > 0) {
          const firstUnit = response?.data[0]?.UnitCode || "";
          setUintData(response?.data);

          setItemDetails((prev) => ({
            ...prev,
            unit: firstUnit,
          }));

          loader.style.display = "none";
        }
      }
    } catch (error) {
      setUintData([]);
      setItemDetails((prev) => ({
        ...prev,
        unit: "",
      }));

      loader.style.display = "none";
      console.error("Error fetching cycle count data:", error);
    }
  };

  const fbarcodeScan = (e, index) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      getBarcodeApi(index);
    }
  };

  const fClear = () => {
    setItemDetails({
      barcode: "",
      itemCode: "",
      itemName: "",
      srNo: 0,
      baseQty: 0,
      quantity: 0,
      unit: unitData.length > 0 ? unitData[0]?.UnitCode : "",
    });
    setUintData([]);
    setErrors(initError);
  };

  const fNew = (index) => {
    fClear();
    getRowDetailApi(index);
    setTimeout(() => {
      document.getElementById(`barcode-${index}`)?.focus();
    }, 600);
    setIsGridLoading(true);
  };

  const fDelete = (index) => {
    confirmAlert({
      title: "Delete",
      message: "Are you want to delete?",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: () => {
            deleteApi(index);
            setTimeout(() => {
              document.getElementById(`barcode-${index}`)?.focus();
            }, 500);
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => "",
        },
      ],
    });
  };

  const fContent_Focus = (e) => {
    if (e.target.value == 0) {
      setItemDetails((obj) => ({
        ...obj,
        [e.target.name]: "",
      }));
    }
  };
  const fContent_Blur = (e) => {
    if (e.target.value == "") {
      setItemDetails((obj) => ({
        ...obj,
        [e.target.name]: (0).toFixed(2),
      }));
    }
  };

  return (
    <div>
      <Grid
        container
        //   columnSpacing={{ xs: 0.5, sm: 1, md: 1, lg: 1 }}
        rowSpacing={{ xs: 1.5, sm: 1, md: 0, lg: 0 }}
      >
        <Grid item xs={12} sm={12} md={8}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6.5} md={6} lg={5.5}>
              <TextField
                label="Barcode"
                value={itemDetails?.barcode || ""}
                fullWidth
                id={`barcode-${index}`} // Ensure unique ID for each accordion
                name="barcode"
                onChange={(event) => {
                  const newValue = event.target.value;

                  setItemDetails((prev) => {
                    if (
                      newValue.trim() === "" ||
                      event.nativeEvent.inputType === "deleteContentBackward"
                    ) {
                      return {
                        ...prev,
                        barcode: newValue,
                        itemCode: "",
                        itemName: "",
                        quantity: 0,
                        unit: "",
                      };
                    }

                    return {
                      ...prev,
                      barcode: newValue,
                    };
                  });

                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    barcode: "",
                  }));
                }}
                onKeyDown={(e) => fbarcodeScan(e, index)}
                autoComplete="off"
                error={errors?.barcode === "" ? false : true}
                helperText={errors?.barcode}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    paddingRight: "0px !important",
                  },
                  "& .MuiInputBase-input": {
                    padding: "5.5px 0px 5.5px 10px !important",
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={(e) => fbarcodeScan(e, index)}
                        sx={{
                          "& .MuiButtonBase-root": {
                            padding: "0px !important",
                          },
                        }}
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            {/* <Grid
                      item
                      xs={0.1}
                      sm={0.1}
                      md={0.1}
                      lg={0.1}
                      visibility={"hidden"}
                    >
                      <TextField
                        label="Item Code"
                        value={itemDetails?.itemCode}
                        name="itemCode"
                        error={errors?.itemCode === "" ? false : true}
                        helperText={errors?.itemCode}
                        fullWidth
                        disabled={true}
                        autoComplete="off"
                      />
                    </Grid> */}

            <Grid item xs={2.5} sm={1.6} md={1.6} lg={1.2}>
              <TextField
                sx={{
                  ".MuiOutlinedInput-root": {
                    paddingRight: "0px !important",
                  },
                }}
                label="Qty"
                value={itemDetails?.quantity}
                fullWidth
                id={`quantity-${index}`}
                name="quantity"
                onChange={(event) => {
                  handleDetailChange("quantity", event.target.value);
                }}
                error={errors?.quantity === "" ? false : true}
                helperText={errors?.quantity}
                onKeyUp={(e) => {
                  fKeyTabInput(e, "unit");
                }}
                onFocus={fContent_Focus}
                onBlur={fContent_Blur}
                autoComplete="off"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            {/* <Grid
                      item
                      xs={0.1}
                      sm={0.1}
                      md={0.1}
                      lg={0.1}
                      visibility={"hidden"}
                    >
                      <TextField
                        value={itemDetails?.itemName}
                        onChange={(event) => {
                          const newItemName = event.target.value;
                          handleDetailChange("itemName", newItemName);
  
                          setErrors({ ...errors, itemName: "" });
                        }}
                        label="Item Name"
                        fullWidth
                        id="itemName"
                        error={errors?.itemName === "" ? false : true}
                        helperText={errors?.itemName}
                        disabled
                        autoComplete="off"
                      />
                    </Grid> */}
            <Grid item xs={9.5} sm={3.8} md={3.5} lg={2.5}>
              <FormControl fullWidth>
                <InputLabel>Unit</InputLabel>
                <Select
                  label="Unit"
                  value={itemDetails?.unit || ""}
                  id="unit"
                  name="unit"
                  onChange={(event) =>
                    handleDetailChange("unit", event.target.value)
                  }
                  error={errors?.unit === "" ? false : true}
                  helperText={errors?.unit}
                  autoComplete="off"
                >
                  {unitData?.map((unit) => (
                    <MenuItem key={unit.UnitCode} value={unit.UnitCode}>
                      {unit.UnitName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <Stack
            spacing={1}
            mt={vMediaQuery ? 0 : 0}
            sx={{
              display: "flex",
              justifyContent: "end",
              textAlign: "end",
            }}
            direction={{ xs: "row" }}
          >
            <Button
              variant="contained"
              sx={{
                height: vMediaQuery ? "24px" : "30px",

                mr: 1,
                textTransform: "capitalize",
              }}
              // disabled = {rowData?.A_Status !== "ENTER"}
              onClick={() => fNew(index)}
            >
              New
            </Button>
            <Button
              variant="contained"
              sx={{
                height: vMediaQuery ? "24px" : "30px",

                mr: 1,
                textTransform: "capitalize",
              }}
              onClick={() => handleSave(index)}
              disabled={rowData?.A_CountStatus !== "ENTER"}
            >
              Save
            </Button>
            <Button
              variant="contained"
              color="primary"
              sx={{
                height: vMediaQuery ? "24px" : "30px",

                textTransform: "capitalize",
              }}
              disabled={rowData?.A_CountStatus !== "ENTER"}
              onClick={() => fDelete(index)}
            >
              Delete
            </Button>
          </Stack>
        </Grid>
      </Grid>
      {isGridLoading && (
        <Box
          sx={{
            mt: vMediaQuery ? 1 : 2,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            height: "16vh",
            width: "100%",
          }}
        >
          <DataGrid
            rowHeight={30}
            headerHeight={40}
            rows={detailGridData}
            columns={[
              {
                field: "C_SrNo",
                headerName: "Sr No",
                width: 80,
                hide: vMediaQuery ? true : false,
              },
              {
                field: "C_Barcode",
                headerName: "Barcode",
                width: vMediaQuery ? 130 : 150,
              },
              {
                field: "C_Qty",
                headerName: "Qty",
                width: vMediaQuery ? 50 : 70,
                headerAlign: "center",
                align: "center",
              },
              {
                field: "C_Unit",
                headerName: "Unit",
                width: 100,
                hide: true,
              },
              {
                field: "C_UnitName",
                headerName: "Unit",
                width: vMediaQuery ? 120 : 150,
              },
              {
                field: "C_BaseQty",
                headerName: "BaseQty",
                width: 80,
                headerAlign: "center",
                align: "center",
                hide: vMediaQuery ? true : false,
              },
            ]}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            hideFooter
            onRowClick={(params) => handleRowClick(params.row, index)}
          />
        </Box>
      )}
    </div>
  );
};

export default AccordianDetailsV1;
